import React, { useMemo, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { listarProyecto } from "../../../../actions/cursosActions";
import { updateStateModalBasic } from "../../../../actions/modalActions";
import { avisoCargando, avisoCorrecto, avisoError } from '../../../../view/components/AvisosMensajes/MensajesSwalf'
import { cambiarPlanMatricula } from "../../../../actions/matriculasActions";


// Datos de ejemplo por defecto (puedes reemplazarlos por los que vengan de tu backend)
const DEFAULT_MODALIDADES = [
  { id: 1, nombre: "AL CONTADO" },
  { id: 2, nombre: "MENSUALIDADES" },
  { id: 3, nombre: "CUOTAS" },
];

const CambiarPlanMatricula = ({
  planActual = "",
  nombrePlanActual = "",
  proyectoId,
  idMatricula,
  dni
}) => {
  const dispatch = useDispatch();
  const [planesPorModalidad, setPlanesSelect] = useState([]);

  const proyecto = useSelector((state) => state.cursos.proyecto);
  const obtenerPlanes = (modalidad) => {
    // Verificar que proyecto y proyecto.planes existan antes de intentar acceder a sus propiedades
    //setModalidadSelect(modalidad);
    if (proyecto && proyecto.planes) {
      if (modalidad === 1) {
        setPlanesSelect(proyecto.planes.planPagoUnico || []);
      } else if ( modalidad === 2) {
        setPlanesSelect(proyecto.planes.planPagosMensualidades || []);
      } else if (modalidad === 3) {
        setPlanesSelect(proyecto.planes.planPagoCuotas || []);
      }
    } else {
      setPlanesSelect([]); // En caso de que proyecto o planes no estén disponibles, se asegura de no romper el código.
    }

  };

  const [modalidadSel, setModalidadSel] = useState("");

  // 2) Siempre convertir a array (si no hay planes aún, array vacío)
  const planesEf = Array.isArray(planesPorModalidad) ? planesPorModalidad : [];

  // Usa datos externos si llegan por props; si no, usa los de ejemplo.
  const modalidadesEf = DEFAULT_MODALIDADES;

  const [planSel, setPlanSel] = useState(planActual || "");

  const guardarPlan = (plan) => {

    if(idMatricula === undefined){
      avisoError("No se encontro la matricula a modificar.");
      return;
    }

    if(plan.planId === planActual){

      avisoError("El plan seleccionado es el mismo que el actual.");
      return;
    }


    dispatch(cambiarPlanMatricula({idMatricula, idPlan: plan.planId, dni}))


    dispatch(updateStateModalBasic()); // Cerrar modal después de guardar

  };

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(listarProyecto(proyectoId)); // Esperar hasta que se obtenga el proyecto
    };

    fetchData();
  }, []);

  useEffect(() => {
  if (modalidadSel) {
    obtenerPlanes(parseInt(modalidadSel));
  }
}, [proyecto]);


  // Si cambia la modalidad y el plan actual ya no pertenece, resetear selección de plan
  useEffect(() => {
    if (!planesEf.some((p) => String(p.id_plan) === String(planSel))) {
      setPlanSel("");
    }
  }, [modalidadSel]); // eslint-disable-line react-hooks/exhaustive-deps



  return (
    <div className="cambiar-plan-matricula container py-3">
      <div
        className="card shadow-sm border-0 p-3 mx-auto"
        style={{ maxWidth: "650px", borderRadius: "1rem" }}
      >
        <div className="text-center mb-4">
          <h2 className="fw-semibold mb-2 text-primary">
            Cambiar Plan de Matrícula
          </h2>
          <p className="text-secondary mb-0">
            Plan actual:&nbsp;
            <span className="fw-bold text-dark">
              { nombrePlanActual || "No asignado"}
            </span>
          </p>
        </div>

        <div className="row g-4">
          <div className="col-md-6">
            <label className="form-label fw-semibold" htmlFor="modalidadSelect">
              Modalidad
            </label>
            <select
              id="modalidadSelect"
              className="form-select form-select-lg border-0 shadow-sm"
              style={{ backgroundColor: "#f9fafb", borderRadius: "0.75rem" }}
              value={modalidadSel}
              onChange={(e) => {
  const modalidad = e.target.value;
  setModalidadSel(modalidad);
  setPlanSel("");
  obtenerPlanes(parseInt(modalidad));
}}

            >
              <option value="">Seleccione una modalidad...</option>
              {modalidadesEf.map((m) => (
                <option key={m.id} value={m.id}>
                  {m.nombre}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-6 d-flex flex-column">
            <label className="form-label fw-semibold" htmlFor="planSelect">
              Plan
            </label>
            <select
              id="planSelect"
              className="form-select form-select-lg border-0 shadow-sm"
              style={{ backgroundColor: "#f9fafb", borderRadius: "0.75rem" }}
              value={planSel}
              onChange={(e) => setPlanSel(e.target.value)}
              disabled={!modalidadSel}
            >
              <option value="">
                {modalidadSel
                  ? "Seleccione un plan..."
                  : "Seleccione una modalidad primero"}
              </option>
              {planesEf.map((p) => (
                <option key={p.id_plan} value={p.id_plan}>
                  {p.nombre_plan}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="mt-5 text-center">
          <button
            type="button"
            className="btn btn-primary btn-lg px-5 shadow-sm"
            disabled={!modalidadSel || !planSel}
            style={{ borderRadius: "2rem" }}
            onClick={() =>
              guardarPlan?.({ planId: planSel })
            }
          >
            Guardar cambio
          </button>
        </div>
      </div>
    </div>
  );
};

CambiarPlanMatricula.propTypes = {
  planActual: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSeleccionar: PropTypes.func,
  modalidades: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      nombre: PropTypes.string.isRequired,
    })
  ),
  planesPorModalidad: PropTypes.object, // { [modalidadId]: Array<{ id, nombre }> }
};

export default CambiarPlanMatricula;
